import { render, staticRenderFns } from "./new-deduction.vue?vue&type=template&id=18929dc5"
import script from "./new-deduction.vue?vue&type=script&lang=js"
export * from "./new-deduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports